import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';
import { KPI } from '../../../../@core/api';
import { InitiativesService, PerimeterStatsService, PerimetersService } from '../../../../@core/utils';
import { EmissionFactorListDialogComponent } from '../../emission-factor-list-dialog/emission-factor-list-dialog.component';
import { NbDialogService, NbAccordionModule } from '@nebular/theme';
import { switchMap } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { AgGridSiteProvidersComponent } from '../../ag-grid-site-providers/ag-grid-site-providers.component';


export interface CollapsableEnergyTypes extends KPI.InitiativeEnergyType {
  collapsed: boolean;
}

@Component({
    selector: 'app-emission-factors-details',
    styleUrls: ['./emission-factors-details.component.scss'],
    templateUrl: './emission-factors-details.component.html',
    standalone: true,
    imports: [
    NbAccordionModule,
    AgGridSiteProvidersComponent,
    TranslateModule
],
})
export class EmissionFactorsDetailsComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];
  public sitesId: number[] = [];
  public sites: string = '';
  public energyTypes: CollapsableEnergyTypes[] = [];

  constructor(
    private perimetersService: PerimetersService,
    private initiativesService: InitiativesService,
    private dialogService: NbDialogService,
    private perimeterStatsService: PerimeterStatsService
  ) {
  }

  public ngOnInit(): void {
    this.subscriptions.push(
      this.perimetersService.perimeters$.pipe(
        switchMap((perimeters) => {
          const siteIds = perimeters.map(perimeter => perimeter.id);
          return combineLatest([
            this.perimeterStatsService.perimeterEnergyIds(siteIds),
            this.initiativesService.initiativeEnergyTypes$
          ]);
        })
      ).subscribe(([energyIds, energyTypes]) => {
        this.energyTypes = energyTypes
          .filter((et) => energyIds.includes(et.id) && !et.is_unspecified)
          .map((energyType, i) => ({
            ...energyType,
            collapsed: i !== 0,
          }))
          .sort((a, b) => a.order - b.order);
      })
    );
  }

  public collapsedChange(index: number, collapsed: boolean): void {
    this.energyTypes[index].collapsed = collapsed;
  }

  public seeEmissionFactorList(
    event: Event,
    energyType: KPI.InitiativeEnergyType,
  ): void {
    event.stopPropagation();
    event.preventDefault();
    this.dialogService.open(
      EmissionFactorListDialogComponent,
      {
        autoFocus: false,
        context: {
          energyTypeId: energyType.id,
          energyTypeName: energyType.name,
          displayRadio: false,
        }
      }
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
